import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Moderation } from '../classes/moderation';
import { DateCalculationService } from './date-calculation.service';
import { TokenService } from './token.service';
import {catchError} from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  constructor(private http: HttpClient, private dateService: DateCalculationService, private tokenService : TokenService) { }

  /**
   * Fonction test appel serveur
   */
  testWebService() {
    const httpHeaders = this.tokenService.loadToken();
    return this.http.post('/api/traitement/test',{}, {headers: httpHeaders});
  }


  /***
   * Fonction recuperation Donneee Fiche PTL Recues
   */
  getReportingGeneral(objEnvoi: any) {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/reporting/getReportingGeneral';
    console.log(objEnvoi);
    return this.http.post(request, objEnvoi, {headers : httpHeaders});
  }
  //fin du fichier



  getListeFichesRecues(dateDebut : string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/liste-fiches-recues/?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getListeFichesTraitees(dateDebut : string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/liste-fiches-traitees/?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    
    return this.http.get(request, {headers : httpHeaders});
  }

  getListeKoEnAttenteRetour(dateDebut : string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/liste-fiches-ko-attente?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getMaturiteMoyenne(dateDebut:string,dateFin:string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/maturite?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    return this.http.get(request, {headers : httpHeaders});
  }


  getTauxIso(dateDebut:string,dateFin:string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/taux-iso?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    return this.http.get(request, {headers : httpHeaders});
  }
}
